import React from 'react'
import { Container } from '../../components/container/Container'


const StandardSizeContainer = ({children}) => {
  return (
    <Container className="max-w-7xl mx-auto px-4 md:pt-40 pt-48">{children}</Container>
  )
}

export default StandardSizeContainer